import type { FC, ReactNode } from 'react';
import { cx } from '../../utils/cx';
import styles from './DataTable.module.css';

export interface TableProps {
  children: ReactNode;
  className?: string;
}

export const DataTable: FC<TableProps> = ({ children, className }) => (
  <div className={styles.wrap}>
    <table className={cx(styles.table, className)}>{children}</table>
  </div>
);
